module.exports = __webpack_public_path__ + "img/IMG_8978.78ef3d03.jpg";